import Form_8 from './Form_8-redux';

export default Form_8;
